module.exports = __webpack_public_path__ + "img/企业动态banner.fea62643.png";